import { Outlet } from 'react-router-dom'
import useOnboarding from './useOnboarding'
import { Spinner, TenantImageEnum, useAssetsContext } from 'summon-ui'
import { BackgroundImage, Box } from 'summon-ui/mantine'

const OnboardingLayout = () => {
  const { isProcessing } = useOnboarding()
  const { getTenantImage } = useAssetsContext()
  const onboardingBg = getTenantImage(TenantImageEnum.OnboardingBg)

  return (
    <BackgroundImage src={onboardingBg || ''} className='h-screen'>
      <Box className='h-full'>{isProcessing ? <Spinner /> : <Outlet />}</Box>
    </BackgroundImage>
  )
}

export default OnboardingLayout
